import { Flex } from "@radix-ui/themes";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../ui/card";

export default function ModuleLayout({
  title,
  subtitle,
  header,
  footer,
  meta,
  children,
}: {
  title: string;
  subtitle: string;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  meta?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <Flex align="center" direction="column" className="w-full max-w-5xl">
      {meta}
      <Card className="w-full">
        <CardHeader>
          <Flex width="100%" justify="between">
            <Flex direction="column">
              <CardTitle>{title}</CardTitle>
              <CardDescription>{subtitle}</CardDescription>
            </Flex>
            <Flex>{header}</Flex>
          </Flex>
        </CardHeader>
        <CardContent className="w-full">{children}</CardContent>
        {footer && <CardFooter>{footer}</CardFooter>}
      </Card>
    </Flex>
  );
}
